import { createSelector } from "@ngrx/store";
import { RootState } from "../../root-store/root.state";
import { SeStepperSideNavComponentType } from "../se-stepper-side-nav.models";

export const selectSeStepperSideComponentFeatureState = (state : RootState) => state.seStepperSideNav;

const StepperSideNavIndexing : Record<SeStepperSideNavComponentType, number> = {
    [SeStepperSideNavComponentType.summary]: 0,
    [SeStepperSideNavComponentType.documents]: 1
};

export const selectActiveSeStepperSideComponentState = createSelector(selectSeStepperSideComponentFeatureState, (state) => {
    const sortedTabs = Object.entries(state).filter(([_, component]) => component.active);
    sortedTabs.sort((a, b) => StepperSideNavIndexing[a[0]] - StepperSideNavIndexing[b[0]]);
    return sortedTabs.map(([type, component]) => ({ ...component, type }));
});
